var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"moves-list"}},[_c('h2',{staticClass:"title"},[_vm._v("Lista de Cruces")]),_vm._l((_vm.list),function(crossing){return _c('CrossingRow',{key:crossing.movement_pkey,attrs:{"crossing":crossing}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }